// src/components/transactions/TransactionTable.jsx

import React from "react";
import CustomDataGrid from "../common/CustomDataGrid";
import { transactionColumns } from "../../constants/columns/transactionColumns";

const TransactionTable = ({ transactions }) => {
  return (
    <CustomDataGrid
      rows={transactions}
      columns={transactionColumns}
      getRowId={(row) => row._id || row.id}
    />
  );
};

export default TransactionTable;
